module.exports = __webpack_public_path__ + "img/add-icon.c63a87bd.svg";